import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../store";
import { uploadFileToAzure } from "../../services/azure";
import axios from "axios";
import { pdfjs } from "react-pdf";
import {
  AiOutlineClose,
  AiOutlineCloudUpload,
} from "react-icons/ai";
import { EmptySkill } from "./dashboard";
import { apiGet, apiGetPublic, apiPostPut } from "../../api/api_methods";
import Loader from "../reusble_components/loader";
import { Observer } from "mobx-react";
import DeletePopup from "../recruiter/DeletePopup";
import PdfViewer from "../reusble_components/pdfViewer";
import { IoMdAdd } from "react-icons/io";
import VideoViewer from "../reusble_components/VideoViewer";

export default function ({ onSave }) {
  const [skills, setSkills] = useState([]);
  const { InterviewStore, PopupStore } = useStores();
  const [resume, setResume] = useState("");
  const [defaultSkills, setDefaultSkills] = useState([
    "Python",
    "Java",
    "C++",
    "React",
    "NodeJS",
    "MongoDB",
    "ExpressJS",
  ]);

  const [defaultCities, setDefaultCities] = useState([
    "Visakhapatnam",
    "Hyderabad",
    "Bangalore",
    "Chennai",
    "Pune",
    "Mumbai",
    "Delhi",
  ]);

  const [showSkills, setShowSkills] = useState(true);
  const skillInputRef = useRef(null);
  const cityInputRef = useRef(null);
  const [load, setLoad] = useState(false);
  const [mail, setMail] = useState("");
  const [popup, setPopup] = useState(false);
  const [popupText, setPopupText] = useState("");

  const nameInputRef = useRef(null);
  const collegeInputRef = useRef(null);
  const companyInputRef = useRef(null);
  const mobileInputRef = useRef(null);
  const mailInputRef = useRef(null);
  const qualificationInputRef = useRef(null);
  const departmentInputRef = useRef(null);
  const yearInputRef = useRef(null);
  const yearOfPassingInputRef = useRef(null);
  const designationInputRef = useRef(null);
  const linkedInInputRef = useRef(null);
  const gitHubInputRef = useRef(null);
  const genderInputRef = useRef(null);
  const bioInputRef = useRef(null);
  // const behanceInputRef = useRef(null);
  const [role, setRole] = useState(null);
  const { UserStore } = useStores();
  const studentId = "647ce2e8c41bee677ea39fc4";
  const employeeId = "650befd08b98acd1edca13a8";
  const navigate = useNavigate();
  const [jobType, setJobType] = useState("Job");
  const [pay, setPay] = useState("free");
  const [dob, setDob] = useState("");
  const [resumeLink, setResumeLink] = useState("");
  const [videoResumeLink, setVideoResumeLink] = useState("");

  const [city, setCity] = useState([]);
  const [cityName, setCityName] = useState("");
  const [date, setDate] = useState("");
  const [experiences, setExperiences] = useState([
    {
      company: "",
      designation: "",
      joiningDate: "",
      completionDate: "",
    },
  ]);
  const [salary, setSalary] = useState();
  const [currentSalary, setCurrentSalary] = useState();
  const [yearOfPassing, setYearOfPassing] = useState();
  const [showCity, setShowcity] = useState(false);
  const [bio, setBio] = useState("");
  const [orgValue, setorgValue] = useState(
    JSON.parse(localStorage.getItem("user"))?.cluster
  );
  const [org, setorg] = useState([]);
  const [hit, setHit] = useState(false);
  useEffect(() => {
    getOrg();
  }, []);
  const getOrg = async () => {
    try {
      const res = await apiGetPublic("/cluster/all-clusters");
      if (res.status === 200) {
        setorg(res.body?.data?.clusters);
        setorgValue(JSON.parse(localStorage.getItem("user"))?.cluster);
        // alert(JSON.parse(localStorage.getItem("user")).cluster)
      } else {
        UserStore.setClusterHit(false);
      }
    } catch (error) {
      console.log("error", error);
      UserStore.setClusterHit(false);
    }
  };
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    UserStore.getUserDetails();
    const userDetails = UserStore.userDetails;
    if (userDetails?.previousCompanies) {
      setExperiences(userDetails.previousCompanies);
    }
    if (userDetails?.bio) {
      setBio(userDetails.bio);
    }
    if (userDetails?.resume) {
      setResumeLink(userDetails.resume);
    }
    if (userDetails?.mail) {
      setMail(userDetails.mail);
    }
    // if (userDetails?.videoResume) {
    //   setVideoResumeLink(userDetails.videoResume);
    // }
    if (userDetails?.dob) {
      setDob(userDetails.dob);
      const date = new Date(userDetails.dob);
      const month = date.getMonth() + 1; // Month is zero-based, so add 1
      const day = date.getDate();
      const year = date.getFullYear();

      // Format month and day to have leading zeros if needed
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDay = day < 10 ? `0${day}` : day;

      // Format date in mm-dd-yyyy format
      const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
      console.log("dob", formattedDate);
      setDate(formattedDate);
      UserStore.setDate(formattedDate);
    }
    if (userDetails?.lookingFor) {
      setJobType(userDetails.lookingFor);
    }
    if (userDetails.skills) {
      setSkills(userDetails.skills);
    }

    setIsChecked(userDetails.openForFreeInternship);

    if (userDetails.openForFreeInternship) {
      setPay("free");
    } else {
      setPay("paid");
    }

    if (userDetails?.workPreference) {
      setWorkTypes(userDetails.workPreference);
    }
    if (userDetails?.expectedSalary) {
      setSalary(userDetails.expectedSalary);
    }
    if (userDetails?.currentSalary) {
      setCurrentSalary(userDetails.currentSalary);
    }
    if (userDetails?.yearOfPassing) {
      setYearOfPassing(userDetails.yearOfPassing);
    }
    if (userDetails?.cityPreference) {
      setCity(userDetails.cityPreference);
      console.log("city", userDetails.cityPreference);
    }
    if (userDetails?.experiences > 0) {
      setExperiences(userDetails.experiences);
    }
  }, []);

  const dateConvert = (d) => {
    const date = new Date(d);
    const month = date.getMonth() + 1; // Month is zero-based, so add 1
    const day = date.getDate();
    const year = date.getFullYear();

    // Format month and day to have leading zeros if needed
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    // Format date in mm-dd-yyyy format
    const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
    return formattedDate;
  };

  const removeCity = (cityToRemove) => {
    console.log(cityToRemove);
    setCity(city?.filter((item) => item !== cityToRemove));
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };
  const [workTypes, setWorkTypes] = useState([]);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    // If checked, add the value to the array, otherwise remove it
    if (checked) {
      setWorkTypes([...workTypes, value]);
    } else {
      setWorkTypes(workTypes.filter((type) => type !== value));
    }
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newExperiences = [...experiences];
    newExperiences[index][name] = value;
    setExperiences(newExperiences);
  };

  const handleAddExperience = () => {
    setExperiences([
      ...experiences,
      {
        company: "",
        designation: "",
        joiningDate: "",
        completionDate: "",
      },
    ]);
  };

  const handleDeleteExperience = (index) => {
    const newExperiences = [...experiences];
    newExperiences.splice(index, 1);
    setExperiences(newExperiences);
  };

  useEffect(() => {
    console.log("resume", UserStore.userDetails.resume);
    localStorage.setItem("res", UserStore.userDetails.resume ? true : false);
  }, [UserStore.resumeName]);

  useEffect(() => {
    console.log("resume", UserStore.userDetails.videoResume);
    localStorage.setItem(
      "videoResume",
      UserStore.userDetails.videoResume ? true : false
    );
  }, [UserStore.videoResumeName]);

  const autoGenerateBio = async () => {
    setLoad(true);
    console.log("api called");
    try {
      await UserStore.autoGenerateBio(
        nameInputRef?.current?.value ?? UserStore?.userDetails?.name,
        collegeInputRef?.current?.value ?? UserStore?.userDetails?.college,
        designationInputRef.current?.value ??
          UserStore?.userDetails?.designation,
        qualificationInputRef?.current?.value ??
          UserStore?.userDetails?.qualification,
        yearOfPassing ?? UserStore?.userDetails?.yearOfPassing,
        skills ?? UserStore?.userDetails?.skills
      );
      console.log(UserStore?.date, "After2 date");
    } catch (error) {
      console.error("Error generating bio:", error);
    }
    setLoad(false);
  };

  useEffect(() => {
    // console.log("Hello");
    const userDetails = UserStore.userDetails;
    if (userDetails?.bio) {
      setBio(userDetails.bio);
    }
  }, [autoGenerateBio]);

  const addSkills = () => {
    if (skillInputRef.current.value) {
      if (skills.includes(skillInputRef.current.value)) {
        return alert("Skill already added");
      }
      setShowSkills(true);
      if (skillInputRef.current.value !== "") {
        setSkills([...skills, skillInputRef.current.value]);
      }

      skillInputRef.current.value = "";
    } else {
      alert("skill cannot be empty");
    }
  };

  const removeSkill = (skill) => {
    setSkills(skills.filter((item) => item !== skill));
  };
  const handleFileChange = async (e) => {
    try {
      setLoad(true);
      UserStore.loading = true;
      setLoading(true);
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;

      UserStore.setResumeName(e.target.files[0].name);
      localStorage.setItem("resName", JSON.stringify(e.target.files[0].name));
      console.log("name", UserStore.resumeName);

      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" }
      );
      const url = fileUploaded.url;
      UserStore.loading = false;
      setResumeLink(url);

      UserStore.setResume(url);
      console.log("resume:", UserStore.resume);

      localStorage.setItem("res", JSON.stringify(url));

      let body = { pic: fileUploaded.url };
    } catch (error) {
      UserStore.loading = false;
      console.error("Error uploading file:", error);
    }
  };
  const getLastIdFromUrl = (url) => {
    const segments = url?.split("/");
    return segments[segments?.length - 1];
  };
  const handleVideoChange = async (e) => {
    try {
      UserStore.loading = true;
      const file = e.target.files[0];

      // Check if a file is selected
      if (!file) {
        alert("No file selected. Please upload a file with a .mp4 extension.");
        UserStore.loading = false;
        return;
      }

      // Check if the file is a video and ends with .mp4 extension
      if (!file.type.startsWith("video/") || !file.name.endsWith(".mp4")) {
        alert("Please upload a file with a .mp4 extension.");
        UserStore.loading = false;
        return;
      }

      // Check if the file size is below 40 MB
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 40) {
        alert("File size exceeds 40 MB. Please upload a smaller file.");
        UserStore.loading = false;
        return;
      }

      localStorage.setItem("videoResName", file.name);

      // Generate a unique filename using timestamp and random number
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = `${randomNumber}${timestamp}`;

      // Upload the file to Azure
      const fileUploaded = await uploadFileToAzure(filename, file, {
        action: "resume",
      });
      UserStore.loading = false;

      const url = fileUploaded.url;
      setVideoResumeLink(url); // Update the state to display the video immediately
      console.log("url", url);

      // Update the UserStore and local storage with the uploaded file URL
      UserStore.setVideoResume(url);
      console.log("video resume:", UserStore.videoResume);
      localStorage.setItem("videoRes", url);

      // Optional: send the URL to the server or another function
      const body = { video: fileUploaded.url };
    } catch (error) {
      UserStore.loading = false;
      console.error("Error uploading file:", error);
    }
  };

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);
      InterviewStore.setResumeText(fullText);
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
    }
  };

  const showProfile = async (e) => {
    e.preventDefault();
    handleCloseClick();
    if (skills.length === 0) {
      alert("Please add skills");
      return;
    }
    if (
      UserStore.resume === null &&
      resumeLink === "" &&
      UserStore.userDetails.resume === ""
    ) {
      alert("Please upload your resume");
      return;
    }

    setLoad(true);
    console.log("Hello", videoResumeLink);

    const userDetailslocal = JSON.parse(localStorage.getItem("user"));

    const body = {
      name: e.target.name.value,
      college: e.target?.college?.value,

      cluster: orgValue,
      mobile: e.target.mobile.value,
      // mail: mailInputRef?.current?.value,
      qualification: e.target.qualification.value,
      branch: e.target.branch?.value,
      year: e.target.year?.value,
      yearOfPassing: e.target.yearOfPassing?.value,

      skills: skills,
      // resume: UserStore.resume,
      resumeName: UserStore.resumeName,
      videoResume: UserStore.videoResume ?? videoResumeLink,
      videoResumeName: UserStore?.videoResumeName,
      linkedIn: e.target.linkedIn?.value,
      gitHub: e.target.gitHub?.value,
      gender: e.target.gender?.value,
      bio: e.target.Bio?.value,
      dob: dob,
    };

    console.log("body--", body);

    if (UserStore.resume !== "" && UserStore.resume !== null) {
      body.resume = UserStore.resume;
    } else {
      // alert(UserStore.userDetails.resume);
      body.resume = UserStore.userDetails.resume;
    }
    if (UserStore.videoResume !== "" && UserStore.videoResume !== null) {
      body.videoResume = UserStore.videoResume;
    } else {
      // alert(UserStore.userDetails.videoResume);
      body.videoResume = UserStore.userDetails.videoResume;
    }

    console.log("body---", body);

    const response = await apiPostPut(
      body,
      `/user/user-with-id/${userDetailslocal?._id}`,
      "PUT"
    );
    if (response.status === 200) {
      console.log("output", response?.body?.data);
      handleUpdateClick();

      UserStore.setUserDetails(response?.body?.data);
      localStorage.setItem("user", JSON.stringify(response?.body?.data));
      setLoad(false);
    } else {
      setLoad(false);
      console.log("error", response.body.message);
      return alert(response.body.message);
    }
  };
  const [gender, setGender] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [pdf, setPdf] = useState(false);
  const [video, setVideo] = useState("");
  const [showVideo, setShowVideo] = useState(false);
  const closePopup = () => {
    setPdf(false);
  };

  const handleUpdateClick = () => {
    setShowNotification(true);
  };

  const handleCloseClick = () => {
    setShowNotification(false);
  };

  const handlePdfClick = () => {
    if (UserStore.userDetails.resume !== undefined) {
      setPdf(true);
    }
  };

  useEffect(() => {
    UserStore.setGender(UserStore.userDetails?.gender);
    setSkills(UserStore.userDetails?.skills);

    UserStore.setDate(dateConvert(UserStore.userDetails.dob));
  }, [UserStore.userDetails]);

  const handleGenderChange = (event) => {
    UserStore.setGender(event.target.value);
    setGender(event.target.value);
  };
  return (
    <Observer>
      {() => (
        <>
          <Loader loader={load || loading || UserStore.loading} />
          {pdf && (
            <PdfViewer
              pdfUrl={UserStore?.userDetails?.resume}
              onClose={closePopup}
            />
          )}
          {showVideo && (
            <VideoViewer url={video} onClose={() => setShowVideo(false)} />
          )}
          <div className="h-full border-t">
            <div className="flex justify-between items-center ml-6 font-semibold text-lg mt-2">
              <span className=" md:hidden lg:hidden">Profile Info</span>
              {/* <button
                type="submit"
                className=" flex bg-primary text-white h-10 w-28 md:ml-auto  gap-2 justify-center rounded-xl items-center lg:w-fit lg:h-fit mx-5"
              >
                {" "}
                <span className="">
                  <MdOutlineRefresh />
                </span>
                Auto Fill
              </button> */}
            </div>
            <form onSubmit={showProfile}>
              <div className="flex md:mt-10 lg:mt-10 mt-2 flex-col md:grid md:grid-cols-3  md:px-11 lg:px-11 px-4 md:pl-8 lg:pl-8 md:gap-6 -ml-3 ">
                <div className=" mb-2 flex flex-col  lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2 text-[#626161]">
                    Name of the Student
                  </label>
                  <input
                    type="text"
                    required
                    defaultValue={UserStore?.userDetails?.name}
                    id="name"
                    name="name"
                    className="border rounded border-slate-200 focus:outline-0 focus:border-primary  color5 p-3 mt-1  h-10 text-black  lg:h-12"
                  />
                </div>
                <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2 text-[#626161]" htmlFor="dob">
                    Date of Birth
                  </label>

                  <input
                    type="date"
                    id="dob"
                    name="dob"
                    value={UserStore?.date}
                    min="1000-01-01"
                    max="2020-12-31"
                    required
                    onChange={(e) => {
                      UserStore.setDate(e.target.value);
                      const dobValue = e.target.value; // Get the value of the input field
                      const formattedDate = new Date(dobValue).getTime(); // Use the date string directly
                      setDob(formattedDate); // Set the state to the formatted date string
                      console.log(formattedDate);
                      // const updateBody = {
                      //   ...UserStore.userDetails,
                      //   dob: formattedDate,
                      // };
                      // // console.log("bio", response?.body?.data?.body?.content);
                      // console.log(UserStore?.date, "After1 date");
                      // UserStore.setUserDetails(updateBody);
                    }}
                    className="border rounded border-[#B6B6B6F5] focus:outline-0 focus:border-primary color5 p-3 mt-1 h-10 text-black  lg:h-12"
                  />
                </div>
                <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2 text-[#626161]" htmlFor="mobile">
                    Mobile
                  </label>
                  <input
                    type="number"
                    id="mobile"
                    name="mobile"
                    defaultValue={UserStore?.userDetails?.mobile}
                    required
                    className="border rounded border-[#B6B6B6F5]_color5 p-3 mt-1 focus:outline-0 focus:border-primary  h-10 text-black lg:h-12"
                  />
                </div>
                <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2 text-[#626161]" htmlFor="mail">
                    Email ID
                  </label>
                  <input
                    type="text"
                    id="mail"
                    name="mail"
                    defaultValue={UserStore?.userDetails?.mail}
                    required
                    readOnly
                    className="border rounded border-[#B6B6B6F5]_color5 p-3 mt-1 focus:outline-0 focus:border-primary  h-10 text-black lg:h-12"
                  />
                </div>
                <span className=" flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2 text-[#626161]" htmlFor="linkedIn">
                    LinkedIn URL
                  </label>
                  <input
                    type="text"
                    id="linkedIn"
                    name="linkedIn"
                    placeholder="LinkedIn URL"
                    required
                    defaultValue={UserStore?.userDetails?.linkedIn}
                    className="border rounded border-[#B6B6B6F5]_color5 p-3 mt-1 focus:outline-0 focus:border-primary h-10 text-black  lg:h-12"
                  />
                </span>
                <span className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2  text-[#626161]" htmlFor="gitub">
                    Git-Hub URL
                  </label>
                  <input
                    type="text"
                    id="gitHub"
                    name="gitHub"
                    placeholder="GitHub URL"
                    defaultValue={UserStore?.userDetails?.gitHub}
                    className="border rounded border-[#B6B6B6F5]_color5 p-3 mt-1 focus:outline-0 focus:border-primary h-10 text-black  lg:h-12"
                  />
                </span>

                <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2 text-[#626161]" htmlFor="gender">
                    Gender
                  </label>
                  <select
                    className="border rounded  border-[#B6B6B6F5]_color5 pl-3 mt-1 focus:outline-0 focus:border-primary h-10 lg:h-12 text-black"
                    required
                    id="gender"
                    name="gender"
                    value={UserStore?.gender}
                    onChange={handleGenderChange}
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <span className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5 lg:text-xl col-span-3">
                  <div className="flex items-center justify-between w-full">
                    <label className="lg:pb-2" htmlFor="Bio">
                      Add Bio
                    </label>
                    <span
                      className="text-primary underline cursor-pointer"
                      onClick={autoGenerateBio}
                    >
                      Auto generate
                    </span>
                  </div>
                  <textarea
                    type="textarea"
                    defaultValue={bio}
                    name="Bio"
                    id="Bio"
                    required
                    rows="12"
                    placeholder="Add a short bio about yourself to attract recruiters"
                    className="border  border-gray-300 p-3 h-48 mt-1 focus:outline-0 focus:border-primary text-black rounded-md lg:h-40 "
                  />
                </span>

                <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5 col-span-3">
                  <span className="flex justify-between">
                    <label className="lg:pb-2">Skills you have</label>
                  </span>
                  <div className="flex flex-row border  border-text_color5 mt-1 rounded-xl justify-between items-center">
                    <div className="py-2">
                      {skills?.length === 0 ? (
                        <>
                          {UserStore?.userDetails?.skills?.length === 0 ||
                          !UserStore.showDefault ? (
                            <EmptySkill />
                          ) : (
                            <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
                              {UserStore?.userDetails?.skills?.map(
                                (skill, index) => (
                                  <div
                                    className="flex relative flex-row justify-end py-1"
                                    key={index}
                                  >
                                    <p className="text-[15px] lg:text-xl lg:p-4 lg:px-8 lg:rounded-xl flex items-center gap-2  rounded-lg  bg-primary  text-bg3 py-3 px-4 mr-2">
                                      {skill}{" "}
                                      <AiOutlineClose
                                        className="cursor-pointer text-white"
                                        onClick={() => {
                                          removeSkill(skill);
                                          UserStore.setDefault(false);
                                        }}
                                      />
                                    </p>
                                  </div>
                                )
                              )}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {showSkills && (
                            <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
                              {skills?.map((skill, index) => (
                                <div
                                  className="flex relative flex-row justify-end py-1"
                                  key={index}
                                >
                                  {/* <div className=" cursor-pointer absolute w-4 h-4 text-xs text-bg3 text-center rounded-full mx-1 my-1 bg-text_color3" onClick={() => { removeSkill(skill) }}>x</div> */}

                                  <p className="text-[15px] lg:text-xl lg:p-4 lg:px-8 lg:rounded-xl flex items-center gap-2  rounded-lg  bg-primary  text-bg3 py-1 px-4 mr-2">
                                    {skill}{" "}
                                    <AiOutlineClose
                                      className="cursor-pointer text-white"
                                      onClick={() => {
                                        removeSkill(skill);
                                        UserStore.setDefault(false);
                                      }}
                                    />
                                  </p>
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-row -ml-4 md:ml-0 lg:ml-0 justify-between items-center">
                    <div className="py-2">
                      {defaultSkills && (
                        <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
                          {defaultSkills.map((skill, index) => (
                            <div
                              className="flex relative flex-row cursor-pointer justify-end pt-2"
                              key={index}
                              onClick={() => {
                                if (!skills.includes(skill)) {
                                  setSkills([...skills, skill]);
                                }
                              }}
                            >
                              <p className="text-[15px] lg:text-xl lg:p-4 lg:px-8  flex items-center gap-2  rounded-full  bg-[#D9D9D9]  text-[#818181] py-2 px-4 mr-2">
                                {skill} <IoMdAdd />
                              </p>
                            </div>
                          ))}
                          <div
                            className="flex relative flex-row cursor-pointer justify-end pt-2"
                            onClick={() => {
                              setPopup(true);
                              setPopupText("skill");
                            }}
                          >
                            <p className="text-[15px] lg:text-xl lg:p-4 lg:px-8  flex items-center gap-2  rounded-full  bg-[#000000]  text-white py-1 px-4 mr-2">
                              Add Skill
                              <IoMdAdd />
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="dashed-border border-gray-300 col-span-3"></div>

                <span className="col-span-3 font-bold ml-5 text-lg">
                  College Information
                </span>
                {/* <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label className="lg:pb-2" htmlFor="org">
                    Organization/College
                  </label>
                  <select
                    name="org"
                    id="org"
                    value={orgValue}
                    onChange={(e) => {
                      setorgValue(e.target.value);
                    }}
                    className="border rounded border-[#B6B6B6F5] color5 px-3 mt-1 h-10 text-gray-500  lg:h-12"
                  >
                    {org
                      ?.filter(
                        (org) =>
                          org.listing &&
                          org?.registeredCompanyName !== "Reaidy.io"
                      )
                      .map((org, index) => (
                        <option key={index} value={org?._id}>
                          {org?.registeredCompanyName}
                        </option>
                      ))}

                    {org
                      ?.filter(
                        (org) =>
                          org.listing &&
                          org?.registeredCompanyName === "Reaidy.io"
                      )
                      .map((org, index) => (
                        <option key={index} value={org?._id}>
                          other
                        </option>
                      ))}
                  </select>
                </div> */}
                {orgValue === "65eeb0ff14b93e4c5bc91aef" && (
                  <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                    <label className="lg:pb-2 text-[#626161]" htmlFor="college">
                      Name of the institute
                    </label>
                    <input
                      type="text"
                      name="college"
                      id="college"
                      placeholder="Institute Name"
                      required
                      defaultValue={UserStore?.userDetails?.college}
                      className="border  rounded border-[#B6B6B6F5]_color5 p-3 mt-1 h-10 focus:outline-0 focus:border-primary text-gray-500  lg:h-12"
                    />
                  </div>
                )}

                <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label
                    className="lg:pb-2 text-[#626161]"
                    htmlFor="department"
                  >
                    Branch
                  </label>
                  <input
                    type="text"
                    id="qualification"
                    name="qualification"
                    placeholder="Branch"
                    required
                    defaultValue={UserStore?.userDetails?.qualification}
                    className="border rounded border-gray-200 color5 focus:outline-0 focus:border-primary p-3 mt-1 h-10 text-gray-500  lg:h-12"
                  />
                </div>
                <div className="mb-2 flex flex-col lg:pb-4 lg:p-3 mx-5">
                  <label
                    className="lg:pb-2 text-[#626161]"
                    htmlFor="yearOfPassing"
                  >
                    Select Year
                  </label>
                  <input
                    type="number"
                    id="yearOfPassing"
                    name="yearOfPassing"
                    min="1900"
                    max="2030"
                    placeholder="year"
                    // placeholder="5000"
                    required
                    defaultValue={UserStore?.userDetails?.yearOfPassing}
                    className="border rounded border-[#B6B6B6F5] color5 p-3 focus:outline-0 focus:border-primary mt-1 h-10 text-gray-500  lg:h-12"
                  />
                </div>

                <div className="dashed-border col-span-3  border-gray-300 gap-4"></div>
              </div>
              <label className="px-8 font-bold text-lg md:px-12 lg:px-16">
                Resumes
              </label>
              <div className="flex flex-col  p-2 justify-between -px-16 md:px-11 lg:px-11">
                <input
                  id="fileInput"
                  type="file"
                  className="hidden"
                  onChange={handleFileChange}
                  accept=".pdf"
                />
                <input
                  id="videoInput"
                  type="file"
                  className="hidden"
                  onChange={handleVideoChange}
                  accept=".mp4"
                />
                <span className="flex flex-col md:flex-row px-6 md:px-1 lg:px-1 md:gap-16 lg:gap-16 gap-5 items-center md:items-start">
                  <span className="flex flex-col gap-2 w-full md:w-auto">
                    <label>Resume</label>
                    <div className="border  rounded border-[#B6B6B6F5]_color5 flex justify-between items-center p-3 mt-1 h-10 focus:outline-0 focus:border-primary md:w-[25.2rem] text-gray-500  lg:h-12">
                      {localStorage.getItem("resName") ||
                      UserStore.resumeName ||
                      UserStore.userDetails.resume ? (
                        <p
                          className="w-fit max-w-[75%] py-1.5 px-3 rounded-lg truncate h-8 cursor-pointer bg-[#D9D9D9]"
                          onClick={() => {
                            handlePdfClick();
                          }}
                        >
                          {localStorage.getItem("resName") ??
                            getLastIdFromUrl(UserStore.userDetails.resume)}
                        </p>
                      ) : (
                        <p></p>
                      )}

                      <AiOutlineCloudUpload
                        onClick={() => {
                          document.getElementById("fileInput").click();
                        }}
                        className="text-primary cursor-pointer text-2xl"
                      />
                    </div>
                  </span>
                  <span className="flex flex-col gap-2 w-full md:w-auto">
                    <label className="opacity-70">
                      Video Resume (Optional)
                    </label>
                    <div className="border  rounded border-[#B6B6B6F5]_color5 flex justify-between items-center p-3 mt-1 h-10 focus:outline-0 focus:border-primary md:w-[25.2rem] text-gray-500  lg:h-12">
                      {localStorage.getItem("videoResName") ||
                      UserStore.userDetails.videoResume ? (
                        <p
                          className="w-fit max-w-[75%] py-1.5 px-3 rounded-lg cursor-pointer bg-[#D9D9D9]  truncate h-8"
                          onClick={() => {
                            setShowVideo(true);
                            setVideo(
                              UserStore.videoResume ||
                                UserStore.userDetails.videoResume
                            );
                          }}
                        >
                          {localStorage.getItem("videoResName") ??
                            getLastIdFromUrl(UserStore.userDetails.videoResume)}
                        </p>
                      ) : (
                        <p></p>
                      )}
                      <AiOutlineCloudUpload
                        onClick={() => {
                          document.getElementById("videoInput").click();
                        }}
                        className="text-primary cursor-pointer text-2xl"
                      />
                    </div>
                  </span>
                </span>
              </div>

              <div className="p-6 md:text-xl lg:text-xl">
                {showNotification && (
                  <div className="flex items-center text-primary px-4 pl-12 py-2 rounded-md mt-4">
                    <span>Your details are updated Successfully!</span>
                    {/* <button
                      onClick={handleCloseClick}
                      className="ml-4 font-bold"
                    >
                      &times;
                    </button> */}
                  </div>
                )}
                <div className="flex justify-between items-center  mb-8">
                  <button
                    type="submit"
                    // onClick={handleUpdateClick}
                    className="bg-[#000000] text-white h-10 w-40 rounded-xl  lg:w-fit lg:h-fit md:ml-6 lg:ml-12 ml-20 mx-5"
                  >
                    <p className="lg:py-4 lg:px-24"> Update</p>
                  </button>
                  {/* <p
                    type="submit"
                    onClick={() => UserStore.setDeletePopup(true)}
                    className="  text-gray-400 h-10 w-40 cursor-pointer rounded-xl lg:w-fit lg:h-fit mx-5 flex items-center justify-center"
                  >
                    <p className="lg:py-4 lg:px-24"> Delete Account</p>
                  </p> */}
                </div>
                {UserStore.DeletePopup ? <DeletePopup /> : null}
              </div>
            </form>
            {/* <FreeInterviews completed="4" total= "5"></FreeInterviews> */}

            {popup && (
              <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center gap-8 bg-gray-500 bg-opacity-20 z-50">
                <div className="bg-white p-8 pt-10 rounded-xl relative md:w-fit md:h-fit lg:h-fit lg:w-fit w-[90%] h-[10%]  flex items-center gap-4">
                  <AiOutlineClose
                    onClick={() => {
                      setPopup(false);
                      setPopupText("");
                    }}
                    className="absolute right-2 top-2 cursor-pointer"
                  />
                  <input
                    type="text"
                    placeholder={`Enter ${popupText}`}
                    className="p-2 focus:outline-none  md:w-fit md:h-fit lg:h-fit lg:w-fit w-[90%] h-10 rounded-lg text-2xl bg-gray-300 "
                    {...(popupText === "skill"
                      ? { ref: skillInputRef }
                      : { ref: cityInputRef })}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        if (popupText === "skill") {
                          const newSkill = skillInputRef.current.value;
                          addSkills(newSkill);
                          setPopup(false);
                        } else if (popupText === "city") {
                          const newCity = cityInputRef.current.value;
                          if (city.includes(newCity)) {
                            alert("City already exists");
                          }
                          if (newCity === "") {
                            alert("City cannot be empty");
                          }
                          if (!city.includes(newCity) && newCity !== "") {
                            setCity([...city, newCity]);
                          }
                          setPopup(false);
                        }
                        setPopup(false);
                        setPopupText("");
                      }
                    }}
                  />
                  <button
                    className="bg-primary md:p-3 lg:p-3 p-2 rounded-md text-white"
                    onClick={() => {
                      if (popupText === "skill") {
                        const newSkill = skillInputRef.current.value;
                        addSkills(newSkill);
                        setPopup(false);
                      } else if (popupText === "city") {
                        const newCity = cityInputRef.current.value;
                        if (city.includes(newCity)) {
                          alert("City already exists");
                        }
                        if (newCity === "") {
                          alert("City cannot be empty");
                        }
                        if (!city.includes(newCity) && newCity !== "") {
                          setCity([...city, newCity]);
                        }
                        setPopup(false);
                      }
                      setPopup(false);
                      setPopupText("");
                    }}
                  >
                    {" "}
                    ADD
                  </button>
                </div>
              </div>
            )}
            <div></div>
          </div>
        </>
      )}
    </Observer>
  );
}
